/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Action_Ai_Tailor_CtaInputs */

const en_dashboard_action_ai_tailor_cta = /** @type {(inputs: Dashboard_Action_Ai_Tailor_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start Tailoring`)
};

const de_dashboard_action_ai_tailor_cta = /** @type {(inputs: Dashboard_Action_Ai_Tailor_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anpassung starten`)
};

const fr_dashboard_action_ai_tailor_cta = /** @type {(inputs: Dashboard_Action_Ai_Tailor_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencer l'adaptation`)
};

const es_dashboard_action_ai_tailor_cta = /** @type {(inputs: Dashboard_Action_Ai_Tailor_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar adaptación`)
};

const it_dashboard_action_ai_tailor_cta = /** @type {(inputs: Dashboard_Action_Ai_Tailor_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia a Personalizzare`)
};

const nl_dashboard_action_ai_tailor_cta = /** @type {(inputs: Dashboard_Action_Ai_Tailor_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start Aanpassen`)
};

const pl_dashboard_action_ai_tailor_cta = /** @type {(inputs: Dashboard_Action_Ai_Tailor_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozpocznij dostosowywanie`)
};

const fi_dashboard_action_ai_tailor_cta = /** @type {(inputs: Dashboard_Action_Ai_Tailor_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aloita mukauttaminen`)
};

const da_dashboard_action_ai_tailor_cta = /** @type {(inputs: Dashboard_Action_Ai_Tailor_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start tilpasning`)
};

const sv_dashboard_action_ai_tailor_cta = /** @type {(inputs: Dashboard_Action_Ai_Tailor_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Börja Anpassa`)
};

/**
* | output |
* | --- |
* | "Start Tailoring" |
*
* @param {Dashboard_Action_Ai_Tailor_CtaInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const dashboard_action_ai_tailor_cta = /** @type {((inputs?: Dashboard_Action_Ai_Tailor_CtaInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Action_Ai_Tailor_CtaInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_dashboard_action_ai_tailor_cta(inputs)
	if (locale === "fr") return fr_dashboard_action_ai_tailor_cta(inputs)
	if (locale === "es") return es_dashboard_action_ai_tailor_cta(inputs)
	if (locale === "it") return it_dashboard_action_ai_tailor_cta(inputs)
	if (locale === "nl") return nl_dashboard_action_ai_tailor_cta(inputs)
	if (locale === "pl") return pl_dashboard_action_ai_tailor_cta(inputs)
	if (locale === "fi") return fi_dashboard_action_ai_tailor_cta(inputs)
	if (locale === "da") return da_dashboard_action_ai_tailor_cta(inputs)
	if (locale === "sv") return sv_dashboard_action_ai_tailor_cta(inputs)
	return en_dashboard_action_ai_tailor_cta(inputs)
});